(() => {
  if (window.__battlePdp2026DrawerBound) return;
  window.__battlePdp2026DrawerBound = true;

  let active = null;
  let opener = null;
  let previousOverflow = '';

  function cleanup(dialog) {
    if (active !== dialog) return;
    document.documentElement.style.overflow = previousOverflow;
    active = null;
    const restoreFocus = opener;
    opener = null;
    if (restoreFocus && restoreFocus.isConnected && restoreFocus.getClientRects().length) {
      restoreFocus.focus({ preventScroll: true });
    }
  }

  function bind(dialog) {
    if (dialog.dataset.battleBound) return;
    dialog.dataset.battleBound = 'true';
    dialog.addEventListener('close', () => cleanup(dialog));
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) {
        dialog.close();
      }
    });
    dialog.addEventListener('keydown', (event) => event.stopPropagation());
    dialog.addEventListener('keyup', (event) => event.stopPropagation());
  }

  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-battle-size-close]');
    if (close) {
      const dialog = close.closest('[data-battle-size-drawer]');
      if (dialog && dialog.open) dialog.close();
      return;
    }
    const trigger = event.target.closest('[data-battle-size-open]');
    if (!trigger) return;
    const dialog = document.getElementById(trigger.dataset.battleSizeOpen);
    if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;
    if (active) {
      const oldDialog = active;
      oldDialog.close();
      cleanup(oldDialog);
    }
    bind(dialog);
    opener = trigger;
    previousOverflow = document.documentElement.style.overflow;
    active = dialog;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
  });

  const paymentTypeStyle = `
      #shopify-installments,
      #shopify-installments p,
      #shopify-installments-content,
      #shopify-installments-content span,
      #shopify-installments button {
        font: inherit !important;
        letter-spacing: 0 !important;
      }
  `;
  const paymentRoots = new WeakSet();

  function stylePaymentTerms(host, retries = 8) {
    if (!host.isConnected) return;
    const root = host.shadowRoot;
    if (!root) {
      if (retries > 0) setTimeout(() => stylePaymentTerms(host, retries - 1), 250);
      return;
    }
    if (!root.querySelector('[data-battle-payment-type]')) {
      const style = document.createElement('style');
      style.dataset.battlePaymentType = '2026';
      style.textContent = paymentTypeStyle;
      root.append(style);
    }
    if (!paymentRoots.has(root)) {
      paymentRoots.add(root);
      new MutationObserver(() => stylePaymentTerms(host, 0)).observe(root, { childList: true });
    }
  }

  function syncPaymentTerms() {
    document.querySelectorAll('.battle-pdp-2026 .desktop_main_block .shoppay_banner shopify-payment-terms').forEach(host => stylePaymentTerms(host));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncPaymentTerms, { once: true });
  } else {
    syncPaymentTerms();
  }
  customElements.whenDefined('shopify-payment-terms').then(syncPaymentTerms);
  document.addEventListener('shopify:section:load', syncPaymentTerms);

  document.addEventListener('shopify:section:unload', (event) => {
    if (active && event.target.contains(active)) {
      const dialog = active;
      dialog.close();
      cleanup(dialog);
    }
  });
})();

(() => {
  const instances = new Map();
  function mount(section) {
    if (instances.has(section)) return;
    const bar = section.querySelector('[data-battle-preview]');
    const state = section.querySelector('[data-battle-preview-state]');
    const source = section.querySelector('[data-battle-preview-data]');
    const gallery = section.querySelector('#media-left-column .custom_product_slider') || section.querySelector('#media-left-column');
    const controls = section.querySelector('.desktop_main_block');
    if (!bar || !state || !source || !gallery || !controls) return;
    let data;
    try { data = JSON.parse(source.textContent); } catch { return; }
    const variants = data.variants;
    const image = bar.querySelector('img');
    const initialImage = image?.getAttribute('src');
    document.body.append(bar);
    const cartDrawer = document.querySelector('section[x-show="cart_drawer"]');
    function visible(element) {
      return element && getComputedStyle(element).display !== 'none' && element.getClientRects().length > 0;
    }
    function purchaseButton() {
      return Array.from(controls.querySelectorAll('.width_manage_form button')).find(button => visible(button) && /choose options|add to cart|sold out|unavailable/i.test(button.textContent)) || controls.querySelector('.add_button_product');
    }
    let frame = 0;
    const purchase = controls.querySelector('.width_manage_form');
    function purchaseState() {
      const native = purchase?.querySelector('.add_button_product') || (purchase && Array.from(purchase.querySelectorAll('button, input[type="submit"]')).find(button => /add\s*to\s*cart/i.test(button.textContent || button.value || '')));
      const nativeReady = native && getComputedStyle(native).display !== 'none' && native.getAttribute('x-show')?.includes('all_options_selected');
      return {
        native,
        complete: Boolean(nativeReady) || (state.dataset.complete === 'true' && state.dataset.exists !== 'false'),
        available: Boolean(nativeReady) || state.dataset.available !== 'false'
      };
    }

    function syncPrice() {
      let selected = [];
      try { selected = JSON.parse(state.dataset.options || '[]'); } catch {}
      const summary = bar.querySelector('[data-battle-preview-selections]');
      if (summary) {
        const names = data.optionNames || [];
        const hasSelection = selected.some(Boolean);
        summary.hidden = data.hasOnlyDefaultVariant === true || !hasSelection;
        summary.textContent = summary.hidden ? '' : names.map((name, index) => {
          const value = selected[index];
          if (!value) return `Choose ${name.toLowerCase()}`;
          const match = variants.find(variant => variant.options[index] === value);
          return match?.displayOptions?.[index] || value;
        }).join(' · ');
      }
      const candidates = variants.filter(v => selected.every((value, i) => !value || value === v.options[i]));
      const exact = state.dataset.complete === 'true' ? variants.find(v => String(v.id) === state.dataset.variantId) : null;
      const pool = exact ? [exact] : candidates.length ? candidates : variants;
      if (!pool.length) return;
      const low = pool.reduce((a, b) => a.price < b.price ? a : b);
      const high = pool.reduce((a, b) => a.price > b.price ? a : b);
      bar.querySelector('[data-battle-preview-price]').textContent = low.price === high.price ? low.money : `${low.money} – ${high.money}`;
      const compare = bar.querySelector('[data-battle-preview-compare]');
      const comparable = low.price === high.price && pool.every(v => v.compare > v.price && v.compare === low.compare);
      compare.hidden = !comparable;
      compare.textContent = comparable ? low.compareMoney : '';
      const chosenImage = exact?.image || candidates.find(v => v.image)?.image || initialImage;
      if (image && chosenImage && image.getAttribute('src') !== chosenImage) {
        image.removeAttribute('srcset');
        image.setAttribute('src', chosenImage);
      }
    }
    function update() {
      frame = 0;
      const headerBottom = 0;
      bar.style.setProperty('--battle-preview-top', `${headerBottom}px`);
      const g = gallery.getBoundingClientRect();
      const visibleHeight = Math.max(0, Math.min(g.bottom, window.innerHeight) - Math.max(g.top, headerBottom));
      const remaining = g.height ? visibleHeight / g.height : 1;
      const c = controls.getBoundingClientRect();
      const lastPurchase = purchaseButton();
      const end = lastPurchase ? lastPurchase.getBoundingClientRect().bottom : c.bottom;
      bar.hidden = visible(cartDrawer) || !(window.innerWidth < 768 && g.top < 0 && remaining <= 0.1);
      const action = bar.querySelector('[data-battle-preview-action]');
      if (action) {
        action.hidden = bar.hidden || end > 72;
        const { complete, available, native } = purchaseState();
        action.textContent = !complete ? 'CHOOSE OPTIONS' : available ? 'ADD TO CART' : 'SOLD OUT';
        action.disabled = complete && (!available || Boolean(native?.disabled));
      }
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update); }
    function jump() {
      const g = gallery.getBoundingClientRect();
      const top = parseFloat(bar.style.getPropertyValue('--battle-preview-top')) || 0;
      bar.hidden = true;
      window.scrollTo({ top: Math.max(0, window.scrollY + g.top - top), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    bar.querySelector('[data-battle-preview-image]').addEventListener('click', jump);
    const action = bar.querySelector('[data-battle-preview-action]');
    if (action) action.addEventListener('click', () => {
      const { complete, available, native } = purchaseState();
      if (complete && available && native && !native.disabled) {
        const form = native.form || native.closest('form');
        if (form && typeof form.requestSubmit === 'function') form.requestSubmit(native);
        else native.click();
        const cartTrigger = document.querySelector('a.cart_toggle_mobile[title="Cart"]') || Array.from(document.querySelectorAll('a[href="/cart"]')).find(link => (link.getAttribute('@click.prevent') || '').includes('cart_drawer'));
        if (cartTrigger) cartTrigger.click();
        return;
      }
      const target = Array.from(section.querySelectorAll('.options')).find(visible) || controls.querySelector('.options') || controls;
      const y = window.scrollY + target.getBoundingClientRect().top - bar.getBoundingClientRect().height - 12;
      window.scrollTo({ top: Math.max(0, y), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
    const observer = new MutationObserver(() => { syncPrice(); schedule(); });
    observer.observe(state, { attributes: true });
    if (purchase) observer.observe(purchase, { attributes: true, subtree: true, attributeFilter: ['style', 'disabled', 'class'] });
    if (cartDrawer) observer.observe(cartDrawer, { attributes: true, attributeFilter: ['style', 'class'] });
    const resize = new ResizeObserver(schedule);
    resize.observe(gallery); resize.observe(controls);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    syncPrice(); update();
    instances.set(section, () => {
      bar.remove();
      observer.disconnect(); resize.disconnect(); cancelAnimationFrame(frame);
      window.removeEventListener('scroll', schedule); window.removeEventListener('resize', schedule);
    });
  }
  function init() { document.querySelectorAll('.battle-pdp-2026').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    for (const [section, cleanup] of instances) if (event.target.contains(section)) { cleanup(); instances.delete(section); }
  });
})();

(() => {
  const mounted = new Map();
  function mount(section) {
    if (mounted.has(section)) return;
    let anchor = null;
    let frame = 0;
    let expires = 0;
    let anchorTop = 0;
    function cancel() {
      anchor = null;
      cancelAnimationFrame(frame);
      frame = 0;
    }
    function hold() {
      frame = 0;
      if (!anchor?.isConnected || performance.now() > expires) return cancel();
      const delta = anchor.getBoundingClientRect().top - anchorTop;
      if (Math.abs(delta) > 0.5) window.scrollTo({ top: window.scrollY + delta, left: window.scrollX, behavior: 'instant' });
      frame = requestAnimationFrame(hold);
    }
    function start(event) {
      const option = event.target.closest('.option_maping');
      if (!option || !section.contains(option)) return;
      if (event.type === 'keydown' && !['Enter', ' ', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      if (!anchor) {
        anchor = option;
        anchorTop = option.getBoundingClientRect().top;
      }
      expires = performance.now() + 1200;
      if (!frame) frame = requestAnimationFrame(hold);
    }
    function pointer(event) {
      if (!event.target.closest('.option_maping')) cancel();
      else start(event);
    }
    document.addEventListener('pointerdown', pointer, true);
    section.addEventListener('click', start, true);
    section.addEventListener('change', start, true);
    section.addEventListener('keydown', start, true);
    window.addEventListener('wheel', cancel, { passive: true });
    window.addEventListener('touchmove', cancel, { passive: true });
    function navigation(event) {
      if (['PageUp', 'PageDown', 'Home', 'End', 'Escape'].includes(event.key) || !event.target.closest('.option_maping')) cancel();
    }
    window.addEventListener('keydown', navigation, true);
    mounted.set(section, () => {
      cancel();
      document.removeEventListener('pointerdown', pointer, true);
      section.removeEventListener('click', start, true);
      section.removeEventListener('change', start, true);
      section.removeEventListener('keydown', start, true);
      window.removeEventListener('wheel', cancel);
      window.removeEventListener('touchmove', cancel);
      window.removeEventListener('keydown', navigation, true);
    });
  }
  function init() { document.querySelectorAll('.battle-pdp-2026').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    for (const [section, cleanup] of mounted) if (event.target.contains(section)) { cleanup(); mounted.delete(section); }
  });
})();
